var map = {
	"../chapter/chapter.module": [
		"./src/app/layouts/chapter/chapter.module.ts",
		"common",
		"chapter.module"
	],
	"../finance/finance.module": [
		"./src/app/layouts/finance/finance.module.ts",
		"common",
		"finance.module"
	],
	"../message/message.module": [
		"./src/app/layouts/message/message.module.ts",
		"common",
		"message.module"
	],
	"../product/product.module": [
		"./src/app/layouts/product/product.module.ts",
		"common",
		"product.module"
	],
	"../question/question.module": [
		"./src/app/layouts/question/question.module.ts",
		"common",
		"question.module"
	],
	"../semester/semester.module": [
		"./src/app/layouts/semester/semester.module.ts",
		"common",
		"semester.module"
	],
	"../student/student.module": [
		"./src/app/layouts/student/student.module.ts",
		"common",
		"student.module"
	],
	"../subject/subject.module": [
		"./src/app/layouts/subject/subject.module.ts",
		"common",
		"subject.module"
	],
	"../university/university.module": [
		"./src/app/layouts/university/university.module.ts",
		"common",
		"university.module"
	],
	"../users/users.module": [
		"./src/app/layouts/users/users.module.ts",
		"common",
		"users.module"
	],
	"./layouts/admin-layout/admin-layout.module": [
		"./src/app/layouts/admin-layout/admin-layout.module.ts",
		"common",
		"admin-layout.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main